'use client'

import { Footer, FooterColumnsProps } from '.'
import { generateImageData } from '@/components/atoms/media/umbracoMediaElementPropsFactory'
import { FooterSocialLinksMapper, LinksMapper } from '@/utils/mappingHelpers'
import { GetUmbracoBaseUrl } from '@/utils/urlHelpers'

export default function FooterFactory({ data }: { data: any }) {
  const content = data?.properties
  const mediaItem = content?.logo
  const mediaItemProps = generateImageData(
    { image: mediaItem },
    GetUmbracoBaseUrl(),
  )

  const columns: Array<FooterColumnsProps> = content?.links?.items?.map(
    (item: any) => ({
      category: item?.content?.properties?.category,
      links: LinksMapper(item?.content?.properties?.links),
    }),
  )

  return (
    <Footer
      footerColumns={columns}
      logo={mediaItemProps}
      socialMediaIcons={FooterSocialLinksMapper(
        content?.contactLinks?.items || undefined,
      )}
    />
  )
}
